import React from "react";
import RailServicePage from "./RailServicePage";

export default function BusinessTrainTravel() {
  return (
    <RailServicePage
      eyebrow="Business Train Travel"
      title="Book rail travel for business trips"
      description="Plan efficient city-to-city train travel with schedule-focused options for meetings, conferences, and work trips."
      icon="business"
      highlights={[
        {
          title: "Schedule-first planning",
          text: "Compare departures by arrival windows, direct options, and route timing.",
        },
        {
          title: "Work trip support",
          text: "Get help with booking details, passenger information, receipt questions, and changes.",
        },
      ]}
      steps={[
        "Search stations closest to your meeting or destination.",
        "Compare train timing and estimated fares.",
        "Call support for booking help and travel documentation questions.",
      ]}
    />
  );
}
